import Loader from '@components/shared/loader/Loader';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { matchRoutes, Navigate, Outlet, useLocation } from 'react-router';
import { RoutePaths } from './enums/RoutePaths';
import { useUser } from './hooks/UseUser';
import { useUserDealer } from './hooks/UseUserDealer';
import MainLayout from './layouts/MainLayout';
import { loginRedirect } from './services/auth/AuthService';
import { AppState } from './store/AppState';
import { DealerState } from './types/DealerState';

export const ProtectedRoute: FC = () => {
  const location = useLocation();
  const { user, isLoadingUser, isExpiredUser, isErrorUser } = useUser();
  const { isLoadingUserDealer, storeCode } = useUserDealer();
  const atHomePage = location.pathname.includes(RoutePaths.Home);
  const noLayoutRoutes = [
    { path: RoutePaths.Home },
    { path: RoutePaths.BulkPrint },
    { path: RoutePaths.PWA },
    { path: RoutePaths.PWARequestAccess },
    { path: RoutePaths.PWAError },
    { path: RoutePaths.PWADesktopError },
    { path: RoutePaths.Invitation },
    { path: RoutePaths.GetMobileApp },
  ];

  const matchedNoLayoutRoutes = matchRoutes(noLayoutRoutes, location);

  const { isLoadingDealer } = useSelector<AppState, DealerState>((state) => state.dealer);

  if (isLoadingUser || isLoadingUserDealer) {
    return <Loader />;
  }

  if (!isLoadingUser && (!user || isExpiredUser || isErrorUser)) {
    loginRedirect();
    const pwaInstance = localStorage.getItem('pwa-instance-id');
    const isSharedDevice = localStorage.getItem('isSharedPwaDevice');
    localStorage.clear();
    if (pwaInstance) {
      localStorage.setItem('pwa-instance-id', pwaInstance);
    }
    if (isSharedDevice) {
      localStorage.setItem('isSharedPwaDevice', isSharedDevice);
    }
    return <Loader />;
  }

  if (!atHomePage && location.state && location.state.name !== 'default') {
    if (storeCode === null) {
      return <Navigate to={RoutePaths.Home} state={{ from: location }} replace />;
    } else if (storeCode !== null && isLoadingDealer) {
      return <Loader />;
    }
  }

  return (
    <>
      {!matchedNoLayoutRoutes ? (
        <MainLayout>
          <Outlet />
        </MainLayout>
      ) : (
        <Outlet />
      )}
    </>
  );
};
